import React from 'react';
import { EditorView } from 'prosemirror-view';
import { EditorState } from 'prosemirror-state';

export const ViewContext = React.createContext<{
  state: EditorState;
  dispatch: EditorView['dispatch'];
  focus: () => void;
} | null>(null);

export const ViewProvider = ({ children, value }) => (
  <ViewContext.Provider value={value}>{children}</ViewContext.Provider>
);

export const useView = () => React.useContext(ViewContext);
